import {Button, Col, Form, InputGroup, Modal, Row, Spinner, OverlayTrigger, Tooltip} from "react-bootstrap";
import React, {useEffect} from 'react';
import Dropdown, {components} from "react-select";
import {RiArrowDownSFill} from "react-icons/ri";
import {CiCircleQuestion} from "react-icons/ci";
import {useState} from "react";

export default function AddVmaModal(props) {
    const [isAddingInProgress, setIsAddingInProgress] = useState(false);
    const [validated, setValidated] = useState(false);
    const [modelLabel, setModelLabel] = useState('');
    const [nameInputValue, setNameInputValue] = useState('');
    const customDropdownStyles = {
        control: (provided) => ({
            fontSize: 14,
            ...provided
        }),
        option: (provided) => ({
            ...provided,
            fontSize: 14,
            minHeight: 40,
        })
    }

    const handleSubmit = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        if (form.checkValidity() === true) {
            await handleOk();
        }
        setValidated(true);
    };

    const DropdownIndicator = props => {
        return (components.DropdownIndicator && (<components.DropdownIndicator {...props}>
            <RiArrowDownSFill color={'black'} size={20}/>
        </components.DropdownIndicator>));
    };

    const handleOk = async () => {
        setIsAddingInProgress(true);
        await props.addNewVma(nameInputValue, modelLabel);
        setIsAddingInProgress(false);
    }

    const handleCancel = () => {
        props.setShow(false);
    }

    useEffect(() => {
        if (props.modelDropdownOptions.length > 0) {
            setModelLabel(props.modelDropdownOptions[0].label);
        }
    }, [props.modelDropdownOptions])

    return (
        <Modal dialogClassName="filter-modal" show={props.show} onHide={() => {
            if (!isAddingInProgress) {
                props.setShow(false)
            }
        }} style={{marginTop: '10%', left: '1%'}}>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>Add VMA</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        props.modelDropdownOptions.length > 0 ?
                            <>
                                <Form.Group as={Row} controlId="formPlaintextEmail">
                                    <Form.Label column sm="2">
                                        Name:
                                    </Form.Label>
                                    <Col sm="10">
                                        <InputGroup hasValidation>
                                            <Form.Control
                                                required
                                                type="text"
                                                value={nameInputValue} onChange={(e) => setNameInputValue(e.target.value)}
                                            />
                                            <OverlayTrigger
                                                placement="right"
                                                overlay={
                                                    <Tooltip id="tooltip-right">
                                                        Naming convention:
                                                        <br/>
                                                        &lt;Water System Name&gt;_Supply
                                                        <br/>
                                                        or
                                                        <br/>
                                                        &lt;Water System Name&gt;_Return
                                                    </Tooltip>
                                                }
                                            >
                                                <span style={{marginLeft: '5px', cursor: 'pointer'}}><CiCircleQuestion className={'mt-1'} size={30} color={'#007BFF'}/></span>
                                            </OverlayTrigger>
                                            <Form.Control.Feedback type="invalid">
                                                Please choose a name.
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId="formPlaintextPassword">
                                    <Form.Label column sm="2">
                                        Model:
                                    </Form.Label>
                                    <Col sm="6">
                                        <Dropdown
                                            styles={customDropdownStyles}
                                            options={props.modelDropdownOptions}
                                            defaultValue={props.modelDropdownOptions[0]}
                                            onChange={(value) => {
                                                setModelLabel(value.label);
                                            }}
                                            components={{
                                                IndicatorSeparator: () => null, DropdownIndicator
                                            }}
                                        />
                                    </Col>
                                </Form.Group>
                            </>
                            :
                            <Spinner animation={"border"} variant={"primary"}/>

                    }
                </Modal.Body>
                <Modal.Footer>
                    {
                        isAddingInProgress ?
                            <Button disabled={true} variant="primary"><Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className='mr-1'
                            />
                                Adding...</Button>
                            :
                            <Button type="submit" style={{width: 80}} variant="primary">OK</Button>
                    }

                    <Button disabled={isAddingInProgress} style={{width: 80}} onClick={() => handleCancel()} variant="primary">Cancel</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    )
}
